module.exports='<div class="person-status {{ $ctrl.statusClass }}">{{ $ctrl.statusText }}</div>';